/**
 * Badge — a small pill label (DS core). Solid blue fill + white text; pass a
 * leading icon as the first child (the gap spaces it). Content-agnostic.
 */
import type { ReactNode } from "react";

export function Badge({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <span className={`ds-badge inline-flex items-center gap-1.5 rounded-full bg-ds-accent px-3 py-1 text-ds-14 font-semibold tracking-wide text-white ${className}`}>
      {children}
    </span>
  );
}
